import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mic } from "lucide-react";
import PosterRow from "./PosterRow";
import api from "../lib/api";

function PodcastEmpty() {
  return (
    <section className="px-4 lg:px-14 py-8" data-testid="podcast-spotlight-empty">
      <div className="rounded-[var(--card-radius)] border border-dashed border-[var(--border-accent)] bg-[var(--bg-card)] p-6 text-center sm:p-8">
        <div className="inline-flex items-center gap-2 rounded-full bg-[color:var(--accent)]/15 px-3 py-1 text-xs font-bold uppercase tracking-[0.22em] text-[var(--accent-hover)]">
          <Mic size={14} /> Coming soon
        </div>
        <h2 className="mt-3 font-head text-2xl sm:text-3xl text-[var(--text-primary)]">Podcast Spotlight</h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-[var(--text-secondary)]">Podcast Spotlight is opening soon — submit your show above</p>
        <Link to="/submit?tab=podcast" className="mt-5 inline-flex items-center gap-2 rounded-[var(--card-radius)] border border-[var(--accent)] px-5 py-2.5 text-sm font-bold uppercase tracking-wide text-[var(--accent-hover)] transition-colors hover:bg-[var(--accent)] hover:text-[var(--accent-contrast)]" data-testid="podcast-submit-link">
          Submit your podcast
        </Link>
        <Link to="/creators" className="mt-3 block text-xs font-semibold text-[var(--text-secondary)] underline underline-offset-4 hover:text-[var(--accent-hover)]" data-testid="podcast-how-it-works">How it works</Link>
      </div>
    </section>
  );
}

// Approved TV/film podcasts, or an "opening soon" state until the first approval.
export default function PodcastSpotlight() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/podcasts").then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, []);
  if (items === null) return null;
  if (!items.length) return <PodcastEmpty />;
  return <PosterRow title="Podcast Spotlight" items={items} testid="row-podcast_spotlight" seeAll="/podcasts" />;
}
